/**************************************************
 * Nombre:       Tarjeta_Pregunta
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Collapse, Grid, Typography} from "@mui/material";
import {Add, Remove} from '@mui/icons-material'
import {useState} from "react";

const Tarjeta_Pregunta = ({item}) => {
    const [open, setOpen] = useState(false)

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>


            <Grid container size={{xs: 12, sm: 12, md: 12}}>
                <Grid
                    onClick={() => setOpen(!open)}
                    container
                    justifyContent={'flex-start'}
                    alignItems={'center'}
                    size={{xs: 12, sm: 12, md: 12}}
                    sx={{backgroundColor: '#F2F2F2', p: 1, borderRadius: 2, cursor: 'pointer'}}>


                    <Grid container size={{xs: 1, sm: 1, md: 1}}>
                        {open ? <Remove/> : <Add/>}
                    </Grid>

                    <Grid container size={{xs: 11, sm: 11, md: 11}}>
                        <Typography sx={{fontSize: 18, fontWeight: 600, lineHeight: 1.1}}>{item.pregunta}</Typography>
                    </Grid>

                </Grid>

            </Grid>


            <Collapse in={open} sx={{width: '100%'}}>
                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{mt: 2}}>
                    <Typography>{item.respuesta}</Typography>
                </Grid>
            </Collapse>

        </Grid>
    )

}
export default Tarjeta_Pregunta